import React from "react"
import { AccountData } from "../generated";

export const AccountCircle = (props: { user: AccountData }) => {
    const username = props.user?.nomeOperatore!.trim();
    const split = username.split(" ");
    let usercode = username[0];
    if (split.length > 1 && split[1].length > 0) {
        usercode += split[1][0];
    }
    else {
        usercode += username[1];
    }
    return <div className="rounded-circle bg-primary d-flex justify-content-center align-items-center text-uppercase"
        style={{ width: 30, height: 30, color: "white", fontSize: "1rem" }}>
        {usercode}
    </div>
}